import { Source } from "@xo-union/tk-component-picture";
import { useMastheadContext } from "../../context/mastheadContext.js";
import getCreativeAreaImageSize from "../../utils/getCreativeAreaImageSize.js";
import { jsx as _jsx } from "react/jsx-runtime";
var CreativeSource = function CreativeSource(_ref) {
  var id = _ref.id,
    viewport = _ref.viewport,
    width = _ref.width,
    height = _ref.height;
  var mastheadContext = useMastheadContext();
  var sourceSize = getCreativeAreaImageSize(viewport, mastheadContext.size);
  return /*#__PURE__*/_jsx(Source, {
    viewport: viewport,
    width: width || sourceSize.width,
    height: height || sourceSize.height,
    id: id
  });
};
export default CreativeSource;